import React, { Fragment, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import PageTitle from "../../Layout/AppMain/PageTitle";
import AppContent from "../AppContent";
import {
  Breadcrumb,
  BreadcrumbItem,
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane,
  Card,
  CardBody,
} from "reactstrap";
import classNames from "classnames";
import { ReportNewThreatTab } from "./Tabs/ReportNewThreat";
import { ViewHistory } from "./Tabs/ViewHistory";

export const ContinuousMonitoringPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <AppContent>
      <Fragment>
        <TransitionGroup>
          <CSSTransition
            component="div"
            className="TabsAnimation"
            appear={true}
            timeout={0}
            enter={false}
            exit={false}
          >
            <div>
              <PageTitle
                heading="Continuous Monitoring"
                BreadcrumbComp={
                  <Breadcrumb>
                    <BreadcrumbItem>
                      <a href="#">Home</a>
                    </BreadcrumbItem>
                    <BreadcrumbItem active>
                      Continuous Monitoring
                    </BreadcrumbItem>
                  </Breadcrumb>
                }
              />
              <Card className="main-card mb-6">
                <CardBody>
                  <Nav tabs="true">
                    {["Report New Threat", "View History"].map(
                      (tabName, index) => (
                        <NavItem>
                          <NavLink
                            href="#"
                            className={classNames({
                              active: activeTab === index,
                            })}
                            onClick={() => {
                              if (activeTab !== index) setActiveTab(index);
                            }}
                          >
                            {tabName}
                          </NavLink>
                        </NavItem>
                      )
                    )}
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={0}>
                      <ReportNewThreatTab />
                    </TabPane>
                    <TabPane tabId={1}>
                      <ViewHistory activeTab={activeTab} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    </AppContent>
  );
};
